export { InputAdornment } from './InputAdornment';
export type { InputAdornmentProps } from './InputAdornment';
